import React, { ComponentProps } from 'react';
import {
	FormattedMessage as FormattedMessageComponent,
	useIntl as useIntlLibrary,
} from 'react-intl';
import type { IntlFormatters, IntlShape, MessageDescriptor } from 'react-intl';
import storage from 'store2';

export * from 'react-intl';

export const STORAGE_KEY_SHOW_IDS = 'showIds';

function shouldShowOnlyIds(): boolean {
	return (
		storage.session.get(STORAGE_KEY_SHOW_IDS) &&
		(process.env.TARGET_ENV === 'accept' || process.env.TARGET_ENV === 'nightly')
	);
}

export const useIntl = (): IntlShape => {
	const originIntl = useIntlLibrary();

	const formattersShowingIds: Pick<IntlFormatters, 'formatMessage'> = {
		formatMessage: (descriptor: MessageDescriptor) => {
			return String(descriptor.id);
		},
	};

	return {
		...originIntl,
		...(shouldShowOnlyIds() ? formattersShowingIds : {}),
	};
};

export const FormattedMessage = (
	props: ComponentProps<typeof FormattedMessageComponent>
): JSX.Element => {
	if (shouldShowOnlyIds()) {
		return <>{props.id}</>;
	}

	return <FormattedMessageComponent {...props} />;
};
